import { render } from "./UserList.vue?vue&type=template&id=52459d1b&scoped=true"
import script from "./UserList.vue?vue&type=script&lang=js"
export * from "./UserList.vue?vue&type=script&lang=js"

import "./UserList.vue?vue&type=style&index=0&id=52459d1b&scoped=true&lang=css"

import exportComponent from "D:\\Build Apps\\Natan\\jlm_manager\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52459d1b"]])

export default __exports__